import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const NoOfDoors = ({ noOfDoors }: SpecProps<"no_of_doors">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (noOfDoors == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.no_of_doors",
    message: "Number of doors",
    comment: "Field for 'number of doors' in ad specification",
  });
  const value = formatNumber(noOfDoors, locale);
  return <FieldValuePair field={field} value={value} />;
};
